import {Component, HostListener, Input, OnInit,} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {environment} from "@environment";
import {
  FindUsersDetailsRequest,
  UserDetail,
  UsersDetailFilter
} from '@model';
import {DETAILS} from 'src/app/app-routing.module';
import {AdministratorsService, ExportService} from "@services";
import {debounceTime, distinctUntilChanged, Observable} from 'rxjs';
import {PagingComponent} from "../../../../../components/paging.component";

@Component({
    selector: 'app-list-of-users',
    templateUrl: './list-of-users.component.html',
    styleUrls: ['./list-of-users.component.scss'],
    standalone: false
})

export class ListOfUsersComponent extends PagingComponent<UserDetail> implements OnInit {

  @Input() users: UserDetail[] = [];
  searchText: string = "";
  pageExport: number = 0;
  environment: any = environment;
  selectedRole: number | undefined;
  roles: number[] = UsersDetailFilter.ROLES;
  queryParamsFirstChange: boolean = true;
  filter: FindUsersDetailsRequest | undefined;

  constructor(
    private route: ActivatedRoute,
    private adminService: AdministratorsService,
    private router: Router,
    private exportService: ExportService,
  ) {
    super()
  }


  override ngOnInit(): void {
    super.ngOnInit();
    this.handleExploreResult(this.users);
    this.subsribeToRouteDataChange();
  }

  subsribeToRouteDataChange() {
    this.subscriptions.push(this.route.queryParams.pipe(debounceTime(environment.fullTextSearchDelay),
        distinctUntilChanged()).subscribe((queryParams: any) => {
        this.searchText = queryParams.search ? queryParams.search : "";
        this.selectedRole = this.getRoleValue(queryParams)
        if (!this.queryParamsFirstChange && this.isRoleValid(queryParams.role)) {
          this.onExplore(false);
        }
        this.queryParamsFirstChange = false;
      })
    );
  }

  downloadUsersByRole(type: string) {
    if (this.filter === undefined || this.filter === null || !this.filter) {
      this.filter = this.createFilterExport();
    }

    this.exportService.downloadUsersByRole(type, this.filter);
  }

  private getRoleValue(queryParams: any) {
    if (queryParams.role) {
      return this.isRoleValid(queryParams.role) ? +queryParams.role : undefined
    }
    return undefined;
  }

  private isRoleValid(roleId: string | undefined) {
    if (!roleId) return true;
    else {
      return this.roles.includes(+roleId)
    }
  }

  private changeQueryParams() {
    let queryParams: { [key: string]: any } = {};
    if (this.selectedRole) {
      queryParams['role'] = this.selectedRole;
    }
    if (this.searchText) {
      queryParams['search'] = this.searchText;
    }
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: queryParams,
      replaceUrl: true,
    });
  }

  private createFilterExport() {
    return FindUsersDetailsRequest.createUsersDetailsRequest(
      this.pageExport,
      {
        text: this.searchText !== "" ? this.searchText : undefined,
        role: this.selectedRole ?? undefined
      });
  }

  private createFilter() {
    return FindUsersDetailsRequest.createUsersDetailsRequest(
      this.page,
      {
        text: this.searchText !== "" ? this.searchText : undefined,
        role: this.selectedRole ?? undefined
      });
  }

  protected fetchPage(page: number): Observable<UserDetail[]> {
    let filter: FindUsersDetailsRequest = this.createFilter();
    this.filter = this.createFilterExport();
    return this.adminService.findUsers(filter, true, () => {
      }, () => {
    })
  }

  protected override afterSetItems(items: UserDetail[]): void {
    if (items && items.length > 0) {
      this.users = items;
      this.pageExport++;
    } else {
      this.users = [];
    }
  }

  protected override afterOnExplore(): void {
    this.scrollToTop();
  }


  trackByFn(index: number, item: UserDetail) {
    return item.id;
  }

  handleInput(value: string) {
    this.searchText = value.trim() ?? "";
    this.changeQueryParams()
  }

  onRoleSelect(role?: number) {
    if (this.selectedRole === role || !role) {
      this.selectedRole = undefined;
    } else {
      this.selectedRole = role;
    }
    this.changeQueryParams();
  }


  openUserDetails(user: UserDetail): void {
    this.adminService.currentUserDetails.next(user);
    this.router.navigate([DETAILS], {queryParams: {userId: user.userId}, relativeTo: this.route})
  }
}


